import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "status-lock-small-icon",
  role: "img",
  width: "24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M8.25 11.74c0-1.045.847-1.892 1.893-1.892h3.714c1.046 0 1.893.847 1.893 1.893v2.714a1.893 1.893 0 0 1-1.893 1.893h-3.714a1.893 1.893 0 0 1-1.893-1.893V11.74Zm1.893-.392a.393.393 0 0 0-.393.393v2.714c0 .217.176.393.393.393h3.714a.393.393 0 0 0 .393-.393V11.74a.393.393 0 0 0-.393-.393h-3.714Z" }, null, -1),
    _createElementVNode("path", { d: "M9.421 9.426a2.579 2.579 0 0 1 5.158 0v1.172h-1.5V9.426a1.079 1.079 0 1 0-2.158 0v1.172h-1.5V9.426Z" }, null, -1)
  ])))
}
export default { render: render }